var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartEvent = function SvgStartEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5915 5.00065L11.7118 3.33398H4.6748V17.5007H6.43406V11.6673H10.8322L11.7118 13.334H17.8692V5.00065H12.5915ZM16.11 11.6673H12.5915L11.7118 10.0007H6.43406V5.00065H10.8322L11.7118 6.66732H16.11V11.6673Z"
  })));
};
export default SvgStartEvent;